import React from "react"
import { CONTENT_TYPES } from "@/constants"
import { dynamicWithLoader } from "@/utils/utils"

const Payment = dynamicWithLoader(() => import("@/components/payment/paymentModuleTypes/withStepsSingleOrMultiple/PaymentRefactored"))

const SinglePaymentWithHeading = dynamicWithLoader(
	() => import("@/components/payment/paymentModuleTypes/singleWithHeading/SinglePaymentWithHeading"),
)

const PaymentNoRightSideImage = dynamicWithLoader(
	() => import("@/components/payment/paymentModuleTypes/NoRightSideImageType/PaymentNoRightSideImage"),
)

const PaymentComponent = ({ type, data }) => {
	switch (type) {
		case CONTENT_TYPES.PAYMENT_WITH_STEPS_SINGLE_OR_MULTIPLE_BLOCK:
			return <Payment data={data} /> // mainly use
		case CONTENT_TYPES.PAYMENT_SINGLE_WITH_HEADING_BLOCK:
			return <SinglePaymentWithHeading data={data} />
		case CONTENT_TYPES.PAYMENT_NO_RIGHT_SIDE_IMAGE:
			return <PaymentNoRightSideImage data={data} />
		default:
			return <Payment data={data} />
	}
}

const PaymentMain = ({ data }) => {
	const paymentModuleType = data?.paymentModuleType?.__typename || CONTENT_TYPES.PAYMENT_WITH_STEPS_SINGLE_OR_MULTIPLE_BLOCK
	return <PaymentComponent type={paymentModuleType} data={data} />
}

export default PaymentMain